/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState, useContext, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { useSnackbar } from 'notistack';
import { fileHandler, mapRowData } from 'utils/excelRenderer';
import { toBase64 } from 'utils/fileHelper';
import CasesAPI from 'api/CasesAPI';
import { GlobalContext } from 'providers/GlobalProvider';
import { getNewDocs } from 'utils/resultsComparison';
import AutomationAPI from 'api/AutomationAPI';
import pako from 'pako';
import { format } from 'date-fns';
import { Buffer } from 'buffer';
import PaymentsAPI from 'api/PaymentsAPI';
import { handleUploadNotification } from 'utils/NotificationsFuncs';
interface IUploadFile {
  setUploadMode: any;
  cur_case: any;
}

interface value {
  searchVal: string;
  type: string;
}
export interface automationParams {
  values?: value[];
  entState?: IEntityState;
  comState?: ICommodityState;
  row?: string;
}

interface dataObj {
  type: string;
  searchVal: string;
  row: number;
}

interface IEntityState {
  fuzzy: boolean;
  dateRange: string[];
  lenses: string[];
  countries: string[];
  agencies: string[];
  lists: string[];
}

interface ICommodityState {
  fuzzy: boolean;
  dateRange: string[];
  comLenses: string[];
  countries: string[];
  agencies: string[];
  lists: string[];
}

const UploadFile: React.FC<IUploadFile> = ({ setUploadMode, cur_case }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { cur_user } = useContext(GlobalContext);
  const dt = new Date();
  const dtWithoutTz = new Date(
    dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
  );
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');

  const [file, setFile] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [cols, setCols] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [matchedFormat, setMatchedFormat] = useState(false);
  const [rowData, setRowData] = useState([]);

  const handleCloseModal = () => {
    if (!loading && !saving) {
      setUploadMode(false);
    }
  };

  const reloadPage = () => {
    document.body.style.opacity = '0.5'; // Fade effect
    setTimeout(() => window.location.reload(), 3000);
  };

  const compareHeaders = (arr1: string[]) => {
    if (arr1.length !== cur_case.data.template.length) {
      return false;
    }

    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = cur_case.data.template.slice().sort();

    return sortedArr1.every((value, index) => value === sortedArr2[index]);
  };

  const onDrop = useCallback((acceptedFiles: File[]) => {
    acceptedFiles.forEach(async (accptFile) => {
      const reader = new FileReader();
      reader.onabort = () => {
        enqueueSnackbar('File reading aborted', { variant: 'info' });
      };
      reader.onerror = () => {
        enqueueSnackbar('Error reading file', { variant: 'error' });
      };

      setFile(accptFile);
      const { rows } = await fileHandler(accptFile);
      const colNames: string[] = rows[0];
      if (cur_case.data.template) {
        const tempCheck = compareHeaders(colNames);
        if (tempCheck) {
          setMatchedFormat(true);
        }
      }
      const rowData = rows.slice(1);
      const mappedRowData = mapRowData(colNames, rowData);
      setRows(mappedRowData);
      setCols(colNames);
    });
  }, []);

  const fileValidator = (file: any) => {
    if (file.size > 20000000) {
      enqueueSnackbar('Your file is too large, upload a file less than 20mbs', {
        variant: 'error',
      });
      return {
        code: 'size-too-large',
        message: 'file is larger than 20MB',
      };
    }
    return null;
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: onDrop,
    validator: fileValidator,
    accept: [
      '.doc',
      '.docx',
      '.xml',
      '.xmlx',
      '.csv',
      '.pdf',
      '.img',
      '.jpeg',
      '.png',
      '.xlsx',
      '.xls',
    ],
  });

  const removeFile = () => {
    setFile([]);
    setRows([]);
    setCols([]);
  };

  type Item = {
    type: string;
    searchVal: string;
    row?: number;
  };

  type InputArray = Item[][];

  type OutputArray = Item[][];

  const deduplicateObjects = (input: InputArray): OutputArray => {
    const seen = new Set<string>();

    return input.map((subArray) => {
      return subArray.filter((item) => {
        const key = `${item.type}-${item.searchVal}`;
        if (!seen.has(key)) {
          seen.add(key);
          return true;
        }
        return false;
      });
    });
  };

  const compressData = (data: any) => {
    const stringifiedData = JSON.stringify(data);
    const compressed = pako.gzip(stringifiedData);
    return Buffer.from(compressed).toString('base64'); // Convert to base64 for storage or transmission
  };

  const decompressData = (compressedData: any) => {
    const compressedBuffer = Buffer.from(compressedData[0], 'base64');
    const decompressed = pako.ungzip(compressedBuffer, { to: 'string' });
    return JSON.parse(decompressed);
  };

  const autoAPICall = async (rowsArr: any) => {
    let allResults: any = [];
    let resCount = 0;
    let totalResults = 0;

    const findMatchingIndex = (val: string, arr: any[]): number | false => {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].field === val) {
          return i;
        }
      }
      return false;
    };

    for (const [i, row] of rowsArr.entries()) {
      const query: automationParams = {
        values: row,
        entState: {
          lenses: cur_case.data.entityFilter.lenses,
          countries: cur_case.data.entityFilter.countries,
          agencies: cur_case.data.entityFilter.agencies,
          lists: cur_case.data.entityFilter.lists,
          fuzzy: cur_case.data.entityFilter.entRes,
          dateRange: cur_case.data.entityFilter.filterDate,
        },

        comState: {
          comLenses: cur_case.data.commodityFilter.lenses,
          countries: cur_case.data.commodityFilter.countries,
          agencies: cur_case.data.commodityFilter.agencies,
          lists: cur_case.data.commodityFilter.lists,
          fuzzy: cur_case.data.commodityFilter.entRes,
          dateRange: cur_case.data.commodityFilter.filterDate,
        },
        row: i + 1,
      };

      const res = await AutomationAPI.automationDataSearch(query);
      resCount++;

      if (res?.success) {
        if (res?.result[0].result?.body?.hits?.total?.value) {
          totalResults =
            totalResults + res?.result[0].result?.body?.hits?.total?.value;
        }

        if (res?.result[1].result?.body?.hits?.total?.value) {
          totalResults =
            totalResults + res?.result[1].result?.body?.hits?.total?.value;
        }

        const entityResArr: any[] = [];
        const commodityResArr: any[] = [];

        await res?.result[0].result?.body?.hits?.hits?.forEach((hit: any) => {
          const val = hit.matched_queries ? hit.matched_queries[0] : '';
          const i = findMatchingIndex(val, entityResArr);
          if (i !== false) {
            entityResArr[i].hits++;
            entityResArr[i].docs.push(hit._source);
          } else {
            entityResArr.push({
              field: val,
              row: res.result[0].row,
              dataSet: 'Entites',
              hits: 1,
              docs: [hit._source],
            });
          }
        });
        await res?.result[1].result?.body?.hits?.hits?.forEach((hit: any) => {
          const val = hit.matched_queries ? hit.matched_queries[0] : '';
          const i = findMatchingIndex(val, commodityResArr);
          if (i !== false) {
            commodityResArr[i].hits++;
            commodityResArr[i].docs.push(hit._source);
          } else {
            commodityResArr.push({
              field: val,
              row: res.result[1].row,
              dataSet: 'Commodities',
              hits: 1,
              docs: [hit._source],
            });
          }
        });

        allResults = [...allResults, ...entityResArr, ...commodityResArr];

        if (resCount === rowsArr.length) {
          return {
            all: [...allResults],
            tot: totalResults,
          };
        }
      } else {
        const error_msg =
          'Error screening data. An API call has failed or timed out.';
        enqueueSnackbar(error_msg, { variant: 'error' });
        return {
          all: [],
          tot: 0,
        };
      }
    }
  };

  const handleTicket = async (values: any) => {
    if (cur_case) {
      const update = {
        _id: cur_case.data._id,
        ...values.basics,
        ...values,
      };
      const resp = await CasesAPI.updateCase(update);

      if (resp?.success) {
        enqueueSnackbar('Successfully updated case', { variant: 'success' });
        setLoading(false);
        setUploadMode(false);
        reloadPage();
      } else if (resp) {
        const error_msg =
          'Error updating case. Uploaded file(s) may be too large.';
        enqueueSnackbar(error_msg, { variant: 'error' });
      }
    }
  };

  const screenFile = async (file: any) => {
    setLoading(true);
    let fileInfo = {};
    const base64Str = await toBase64(file);
    fileInfo = {
      uploadedFile: {
        base64: base64Str,
        name: file?.path,
        dateAdded: Date.now(),
        source: true,
      },
    };
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `added the document ${file?.path} and set as the source document`,
      timeStamp: Date.now(),
    };

    const docUpdate = cur_case.data.documents;
    docUpdate.forEach((doc: any) => {
      doc.uploadedFile.source = false;
    });
    docUpdate.push(fileInfo);

    const query = {
      documents: docUpdate,
      status: 'Complete',
      lastUpdate: formatted_dt,
      activity: [...cur_case.data.activity, actObj],
    };

    if (rowData.length > 0) {
      const updatedRows: any[] = [];
      rowData.map((obj: dataObj) => {
        if (obj.searchVal !== ' ') {
          const i = obj.row;
          if (i > updatedRows.length - 1) {
            updatedRows.push([obj]);
          } else {
            updatedRows[i].push(obj);
          }
        }
      });

      const uniqueRows = deduplicateObjects(updatedRows);

      const obj = await autoAPICall(uniqueRows);
      if (obj) {
        const newArr =
          cur_case.data.results.length > 0
            ? getNewDocs(
                decompressData(
                  cur_case.data.results[cur_case.data.results.length - 1]
                    .allResults,
                ),
                obj.all,
              )
            : [];

        const ticketQuery = {
          ...query,
          curTotal: obj.tot,
          curNew: newArr.length,
          results:
            cur_case.data.results.length > 0
              ? [
                  ...cur_case.data.results,
                  {
                    allResults: compressData(obj.all),
                    allTotal: obj.tot,
                    newResults: compressData(newArr),
                    newTotal: newArr.length,
                    date: formatted_dt,
                    docInfo: uniqueRows,
                  },
                ]
              : {
                  allResults: compressData(obj.all),
                  allTotal: obj.tot,
                  newResults: [],
                  newTotal: 0,
                  date: formatted_dt,
                  docInfo: uniqueRows,
                },
        };
        handleTicket(ticketQuery);
      }
    } else {
      handleTicket(query);
    }
  };

  const saveUpload = async (file: any) => {
    if (file.length === 0) {
      setUploadMode(false);
    } else {
      setSaving(true);
      let fileInfo = {};
      const base64Str = await toBase64(file);
      fileInfo = {
        uploadedFile: {
          base64: base64Str,
          name: file?.path,
          dateAdded: Date.now(),
          source: false,
        },
      };
      const actObj: any = {
        user: {
          kc_id: cur_user.basics?.id,
          email: cur_user.basics?.email,
          firstName: cur_user.basics?.firstName,
          lastName: cur_user.basics?.lastName,
        },
        action: `added the document ${file?.path}`,
        timeStamp: Date.now(),
      };
      const docUpdate = cur_case.data.documents;
      docUpdate.push(fileInfo);
      const res = await CasesAPI.updateCase({
        _id: cur_case.data._id,
        documents: docUpdate,
        activity: [...cur_case.data.activity, actObj],
      });
      if (res?.success) {
        enqueueSnackbar('File uploaded!', { variant: 'success' });
        setSaving(false);
        setUploadMode(false);
        const currentEmail = cur_user.basics?.email;
        const ownerEmail = cur_case.data.owner?.email;

        // iterate over sharedWith
        cur_case.data.sharedWith.forEach((email: string) => {
          if (email !== currentEmail) {
            // don’t notify the current user
            handleUploadNotification(
              cur_case.data.ticketName,
              cur_user,
              email,
              cur_case.data._id,
            );
          }
        });

        // If current user is in sharedWith but not the owner, also notify the owner
        if (
          cur_case.data.sharedWith.includes(currentEmail) &&
          currentEmail !== ownerEmail &&
          ownerEmail
        ) {
          handleUploadNotification(
            cur_case.data.ticketName,
            cur_user,
            ownerEmail,
            cur_case.data._id,
          );
        }
      } else {
        enqueueSnackbar('There was an error saving your file', {
          variant: 'error',
        });
        setSaving(false);
        setUploadMode(false);
      }
    }
  };

  const entityHeaders = [
    'Importer of Record Name',
    'Importer of Record',
    'Exporter Name',
    'Buyer Name',
    'Seller Name',
    'Manufacturer Name',
    'Ship To Party',
    'Consolidator (Stuffer) Name',
    'Vessel Name',
    "Carrier's Information",
    'Company Legal Name',
    'Parent Company (If applicable)',
    'Company Identification Number',
    'Contact Person Information',
    'Company Website',
    'Zone Approval Officer',
    'Vessel Name or Aircraft',
    'Name of Facility',
    'Contact Name',
    'Parent Company',
    'Facility Owners',
    'Subcontractors (If Applicable)',
    'Customs Broker Name',
    'Carrier Contact Name',
    'Carrier Name',
    'Consignee Contact Name',
    'Consignee Company Name',
    'Consignee Address',
    'Shipper Email',
    'Shipper Contact Name',
    'Shipper Company Name',
    'Shipper Address',
  ];
  const codeHeaders = [
    'Commodity Harmonized Tariff Schedule Number (HTS)',
    'HS Code',
    'HS Code(s)',
    'Item',
  ];
  const descHeaders = [
    'Product Detailed Information',
    'Description of Merchandise',
    'Item',
    'Assembly Name or Number',
    'Sub Assembly Name or Number',
    'Component / Part Name',
    'Part Number',
    'Description',
    'Description of Goods',
  ];
  const countryHeaders = ['Country of Origin'];

  const mapType = (header: string) => {
    if (cur_case?.data?.colMapping?.length > 0) {
      const foundItem = cur_case.data.colMapping.find(
        (item: any) => item.val === header,
      );
      return foundItem ? foundItem.prop : undefined;
    }
    if (entityHeaders.includes(header)) {
      return 'entity';
    } else if (codeHeaders.includes(header)) {
      return 'code';
    } else if (descHeaders.includes(header)) {
      return 'desc';
    } else if (countryHeaders.includes(header)) {
      return 'country';
    }
    return 'exclude';
  };

  const valsArrofObjs: any = [];

  useEffect(() => {
    if (rows.length > 0) {
      rows.forEach((row: any, i: number) => {
        Object.keys(row).forEach((key) => {
          const obj = {
            type: mapType(key),
            searchVal: row[key],
            row: i,
          };
          if (obj.type) {
            valsArrofObjs.push(obj);
          }
        });
      });
      setRowData(valsArrofObjs);
    } else {
      setRowData([]);
    }
  }, [rows]);

  return (
    <div className='upload-aff-file-container'>
      <div className='upload-aff-file-header'>
        <div className='upload-aff-file-header-content'>
          <div className='upload-aff-file-header-group'>
            <div className='upload-aff-file-header-primary'>
              Upload and attach a file
            </div>
            <div className='upload-aff-file-header-secondary'>
              {matchedFormat
                ? 'It looks like this document matches the format of your source document. Would you like to make this your new source document and run a screen?'
                : 'Upload and attach a file.'}
            </div>
          </div>
        </div>
        <div className='upload-aff-file-header-close' onClick={handleCloseModal}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='var(--card-text)' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      {loading ? (
        <div className='bill-container-fit-screen-content'>
          <div className='loading-spinner-cont-modal'>
            <svg
              className='spinner'
              xmlns='http://www.w3.org/2000/svg'
              width='32'
              height='33'
              viewBox='0 0 32 33'
              fill='none'
            >
              <g clipPath='url(#clip0_4006_13811)'>
                <circle
                  cx='16'
                  cy='3.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.1'
                />
                <circle
                  opacity='0.45'
                  cx='16'
                  cy='29.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.65'
                />
                <circle
                  cx='3'
                  cy='16.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.85'
                />
                <circle
                  cx='29'
                  cy='16.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.35'
                />
                <circle
                  cx='26'
                  cy='7.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.25'
                />
                <circle
                  cx='26'
                  cy='25.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.45'
                />
                <circle
                  cx='6'
                  cy='25.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.75'
                />
                <circle cx='6' cy='7.75' r='3' fill='white' />
              </g>
              <defs>
                <clipPath id='clip0_4006_13811'>
                  <rect
                    width='32'
                    height='32'
                    fill='white'
                    transform='translate(0 0.75)'
                  />
                </clipPath>
              </defs>
            </svg>
            <p>Screening in Progress...</p>
          </div>
        </div>
      ) : saving ? (
        <div className='bill-container-fit-screen-content'>
          <div className='loading-spinner-cont-modal'>
            <svg
              className='spinner'
              xmlns='http://www.w3.org/2000/svg'
              width='32'
              height='33'
              viewBox='0 0 32 33'
              fill='none'
            >
              <g clipPath='url(#clip0_4006_13811)'>
                <circle
                  cx='16'
                  cy='3.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.1'
                />
                <circle
                  opacity='0.45'
                  cx='16'
                  cy='29.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.65'
                />
                <circle
                  cx='3'
                  cy='16.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.85'
                />
                <circle
                  cx='29'
                  cy='16.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.35'
                />
                <circle
                  cx='26'
                  cy='7.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.25'
                />
                <circle
                  cx='26'
                  cy='25.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.45'
                />
                <circle
                  cx='6'
                  cy='25.75'
                  r='3'
                  fill='white'
                  fillOpacity='0.75'
                />
                <circle cx='6' cy='7.75' r='3' fill='white' />
              </g>
              <defs>
                <clipPath id='clip0_4006_13811'>
                  <rect
                    width='32'
                    height='32'
                    fill='white'
                    transform='translate(0 0.75)'
                  />
                </clipPath>
              </defs>
            </svg>
            <p>Saving Document...</p>
          </div>
        </div>
      ) : (
        <div className='upload-aff-file-body'>
          <div className='upload-aff-file-body-frame'>
            <div {...getRootProps()} style={{ width: '100%' }}>
              <div className={`files-container-empty ${file?.name ? 'file-uploaded' : ''}`}>
                {file?.name ? (<>
                  <p className='files-container-text'>
                    <span className='bill-container-fit-screen-content-row-highlight-blue cursor-pointer'>{file.name} </span>
                    <svg onClick={removeFile} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <g id='trash-03'>
                        <path id='Icon' d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167' stroke='var(--card-text)' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </g>
                    </svg>
                  </p>
                </>
                ) : (
                  <>
                    <p className='files-container-text'>
                      <span className='bill-container-fit-screen-content-row-highlight-blue cursor-pointer'>
                        Click to upload
                      </span>{' '}
                      or drag and drop
                    </p>
                    <p className='files-container-text'>
                      CSV, XLS, XLSX, DOC, DOCX, PDF, IMG, PNG, JPEG file
                      formats only (max 200 MB)
                    </p>
                    <input {...getInputProps()} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {matchedFormat ? (
        <div className='upload-aff-file-footer'>
          {!loading && !saving && (
            <div className='upload-aff-file-footer-content'>
              <div
                className='upload-aff-file-footer-cancel'
                onClick={handleCloseModal}
              >
                <div className='upload-aff-file-footer-cancel-text'>Cancel</div>
              </div>
              <div
                className='upload-aff-file-footer-done'
                onClick={() => saveUpload(file)}
              >
                <div className='upload-aff-file-footer-done-text'>
                  Just Upload
                </div>
              </div>
              <div
                className='upload-aff-file-footer-done'
                onClick={() => screenFile(file)}
              >
                <div className='upload-aff-file-footer-done-text'>
                  Upload and Screen
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        !loading &&
        !saving && (
          <div className='upload-aff-file-footer'>
            <div className='upload-aff-file-footer-content'>
              <div
                className='upload-aff-file-footer-cancel'
                onClick={handleCloseModal}
              >
                <div className='upload-aff-file-footer-cancel-text'>Cancel</div>
              </div>
              <div
                className='upload-aff-file-footer-done'
                onClick={() => saveUpload(file)}
              >
                <div className='upload-aff-file-footer-done-text'>Done</div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default UploadFile;
